import * as React from "react";

;
export const SwitchOn = (props: React.SVGProps<SVGSVGElement>) => <svg width={48} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={48} height={24} rx={12} fill="#3FD899" /><circle cx={35.5} cy={12} r={10.5} fill="#fff" /></svg>;